/* ===========================================================
   lib/katex.js — equations, loaded only when a doc has one

   KaTeX (and its fonts) is ~300 KB, so it stays out of the first
   load. Until it arrives an equation shows as its LaTeX text.
   `trust: false` keeps \href and friends from making links or
   running anything; maxExpand stops macro bombs.
   =========================================================== */

import { esc } from '../../shared/render.js';

let katex = null;
let loading = null;

const OPTS = { throwOnError: false, strict: 'ignore', trust: false, maxSize: 40, maxExpand: 500, output: 'htmlAndMathml' };

export function loadKatex() {
  if (!loading) {
    const css = document.createElement('link');
    css.rel = 'stylesheet';
    css.href = '/vendor/katex/katex.min.css';
    document.head.append(css);
    loading = import('katex').then(m => { katex = m.default || m; return katex; });
  }
  return loading;
}

export const katexReady = () => !!katex;

/** Draw LaTeX into an element (now if KaTeX is here, as soon as it arrives otherwise). */
export function renderMath(el, latex, display) {
  el.classList.toggle('empty', !latex);
  if (!latex) {
    el.textContent = display ? 'Empty equation. Click to write one.' : '…';
    return;
  }
  if (katex) {
    try { katex.render(latex, el, { ...OPTS, displayMode: display }); } catch { el.textContent = latex; }
    return;
  }
  el.textContent = latex;
  loadKatex().then(() => renderMath(el, latex, display)).catch(() => {});
}

/** HTML string for the static renderer (compare, conflict cards). */
export function mathHTML(latex, display) {
  if (!katex) return `<code>${esc(latex)}</code>`;
  try { return katex.renderToString(latex, { ...OPTS, displayMode: display }); } catch { return `<code>${esc(latex)}</code>`; }
}
